var React = require('react');

function LightClient (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27 0H6C2.68594 0 0 2.68594 0 6V42C0 45.3141 2.68594 48 6 48H27C30.3141 48 33 45.3141 33 42V6C33 2.68594 30.3094 0 27 0ZM16.5 45C14.8359 45 13.5 43.6641 13.5 42C13.5 40.3359 14.8359 39 16.5 39C18.1641 39 19.5 40.3359 19.5 42C19.5 43.6641 18.1688 45 16.5 45ZM27 6V36H6V6H27Z"}));
}

LightClient.defaultProps = {"width":"33","height":"48","viewBox":"0 0 33 48"};

module.exports = LightClient;

LightClient.default = LightClient;
